/* MQS V203: keep internal agency links in the current unpublished preview.
 * No fetch requests, page redirects, product filtering or cart changes. */
(function () {
  'use strict';
  if (window.MqsHomeAgencyLinksV203) return;
  window.MqsHomeAgencyLinksV203 = true;
  function update(root) {
    var here = new URL(window.location.href);
    var theme = (window.Shopify || {}).theme || {};
    var preview = here.searchParams.get('preview_theme_id');
    if (!preview && theme.id && theme.role && String(theme.role).toLowerCase() !== 'main') preview = String(theme.id);
    if (!preview || !/^\d+$/.test(preview)) return;
    (root || document).querySelectorAll('[data-mqs-agency-home] a[href]').forEach(function(a) {
      var raw = a.getAttribute('href');
      if (!raw || raw.charAt(0) === '#') return;
      try {
        var url = new URL(raw, here.href);
        if (url.origin !== here.origin || !/^https?:$/.test(url.protocol)) return;
        url.searchParams.set('preview_theme_id', preview);
        a.href = url.pathname + url.search + url.hash;
      } catch (ignore) { /* Leave malformed or non-web links untouched. */ }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){update(document);});
  else update(document);
  document.addEventListener('shopify:section:load', function(){update(document);});
}());
